<template>
  <!-- Overlay centrado en MODO VISTA cuando el binario del parque aún no está disponible
       (recién guardado un diseño → su binario se regenera en segundo plano). Evita el lienzo
       en blanco; se quita solo cuando llega el binario (Pusher) y se recarga la vista. -->
  <div class="absolute w-full" style="top: 50%; left: 50%; transform: translate(-50%, -50%);">
    <div class="flex flex-col items-center text-center pointer-events-none"
      style="width: 440px; margin: 0 auto; color: #0a131c">
      <div class="text-[#3a6bc8]">
        <b-icon pack="fas" icon="rotate" custom-size="fa-3x" custom-class="fa-spin"></b-icon>
      </div>
      <h3 class="font-light text-2xl mt-5">{{ $t('processing_new_design_version') }}</h3>
      <p class="text-sm mt-2.5" style="color: #76767D">{{ $t('design_version_update_auto') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewerBinaryProcessing",
}
</script>
